export enum EPopupDisplayStrategy {
  SINGLE_TIME = 'SINGLE',
  ALWAYS = 'ALWAYS',
}
